const toggleAccordionItem = () => {
	const items = document.querySelectorAll('.accordion__title');
	
	items.forEach((item) => {
		item.addEventListener('click', (evt) => {
			const answerHolder = item.nextElementSibling;

			if (!item.classList.contains('accordion__title--active')) {
				const answer = answerHolder.children[0];
				answerHolder.style.height = `${answer.clientHeight}px`;
			} else {
				answerHolder.style.height = `0px`;
			}

			item.classList.toggle('accordion__title--active');
		});
	});
}

export default toggleAccordionItem;
